exports = module.exports = require("../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-lastpass-icon-root]{display:none!important}", ""]);

// exports
